import React from 'react';
import { Box } from '@wix/design-system';
import EnterCode from '../EnterCode';
import { useTwoFactorAuth } from '../../stores/twoFactorAuth';
import { TwoFAMethods } from '../TwoFAMethods/TwoFAMethods';
import { TwoFAErrorToast } from '../TwoFAErrorToast/TwoFAErrorToast';

export const MoreMethods = () => {
  const { store } = useTwoFactorAuth();

  return (
    <>
      {store.showMethodsSwitch && <TwoFAMethods />}
      <Box marginTop="5px">
        <EnterCode.LostAccess onClick={store.onLostAccess} />
      </Box>
      <Box marginTop="auto" width="100%">
        <TwoFAErrorToast />
      </Box>
    </>
  );
};
